import {
  addUniqueValueToArray
} from 'utils/redux'

export const NAMESPACE = 'KanBo/userActivities/'
export const SET_USER_ID = NAMESPACE + 'SET_USER_ID'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET_CURSOR = NAMESPACE + 'SET_CURSOR'

const initialState = {
  userId: null,
  activities: [],
  activitiesById: {},
  cursor: null,
  isLoading: false,
  isLoaded: false
}

const elementDefaults = {

}

const transformActvity = (activity) => {
  const _activity = {
    ...activity
  }

  if ((activity.data.action === 'EditCommentOnCard' ||
       activity.data.action === 'RemoveCommentFromCard') &&
       activity.data.originalTimestamp) {
    _activity.timestamp = activity.data.originalTimestamp
  }

  return _activity
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case SET_USER_ID:
      return action.payload.userId !== state.userId ? {
        ...initialState,
        userId: action.payload.userId
      } : state
    case SET_LOAD_STATUS:
      return {
        ...state,
        isLoading: action.payload.isLoading,
        isLoaded: action.payload.isLoaded
      }
    case ADD: {
      const activity = transformActvity(action.payload)
      return {
        ...state,
        activities: addUniqueValueToArray({
          array: state.activities,
          value: activity.id,
          index: activity.index
        }),
        activitiesById: {
          ...state.activitiesById,
          [activity.id]: {
            ...elementDefaults,
            ...activity
          }
        }
      }
    }
    case ADD_ARRAY: {
      const newState = {
        ...state,
        activities: [ ...state.activities ],
        activitiesById: { ...state.activitiesById }
      }
      action.payload.forEach(activity => {
        activity = transformActvity(activity)
        newState.activities = addUniqueValueToArray({
          array: newState.activities,
          value: activity.id,
          index: activity.index
        })
        newState.activitiesById[activity.id] = {
          ...elementDefaults,
          ...activity
        }
      })
      return newState
    }
    case REMOVE: {
      const newState = {
        ...state,
        activities: [ ...state.activities.filter(id => id !== action.payload.id) ],
        activitiesById: { ...state.activitiesById }
      }
      delete newState.activitiesById[action.payload.id]
      return newState
    }
    case SET_CURSOR:
      return {
        ...state,
        cursor: action.payload
      }
    default: return state
  }
}

export function setUserId (userId) {
  return {
    type: SET_USER_ID,
    payload: {
      userId
    }
  }
}

export function setLoadStatus ({ isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      isLoading,
      isLoaded
    }
  }
}

export function add (data) {
  return {
    type: ADD,
    payload: data
  }
}

export function addArray (elementsArray) {
  return {
    type: ADD_ARRAY,
    payload: elementsArray
  }
}

export function remove ({ id }) {
  return {
    type: REMOVE,
    payload: {
      id
    }
  }
}

export function setCursor (payload) {
  return {
    type: SET_CURSOR,
    payload
  }
}
